var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#322D29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25,
    height: 25,
    transform: "translate(-0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M121.607,4.956a1.387,1.387,0,0,0,1.386-1.387V1.386a1.387,1.387,0,0,0-2.773,0V3.569A1.387,1.387,0,0,0,121.607,4.956Z",
    transform: "translate(-114.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335.23,4.956a1.387,1.387,0,0,0,1.386-1.387V1.386a1.387,1.387,0,0,0-2.773,0V3.569A1.387,1.387,0,0,0,335.23,4.956Z",
    transform: "translate(-318.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.565,41.287h-.858v1.592a2.605,2.605,0,1,1-5.211,0V41.287H16.481v1.592a2.605,2.605,0,1,1-5.211,0V41.287h-.858a3.339,3.339,0,0,0-3.339,3.339V60.48a3.34,3.34,0,0,0,3.339,3.339H27.565A3.339,3.339,0,0,0,30.9,60.48V44.626A3.34,3.34,0,0,0,27.565,41.287Zm.711,18.606a1.549,1.549,0,0,1-1.548,1.548H11.249A1.549,1.549,0,0,1,9.7,59.893V47.49H28.276v12.4Z",
    transform: "translate(-7.073 -39.311)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(8.791 17.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(8.791 13.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(4.993 17.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(4.993 13.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(16.388 10.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.451,
    height: 2.45,
    transform: "translate(12.59 10.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.451,
    height: 2.45,
    transform: "translate(12.59 13.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(16.388 17.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(16.388 13.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.451,
    height: 2.45,
    transform: "translate(12.59 17.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(8.791 10.199)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.45,
    height: 2.45,
    transform: "translate(4.993 10.199)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarOff);
export default __webpack_public_path__ + "static/media/icon_calendar_off.b5a6e7116761cae611fa1642f2b53b0b.svg";
export { ForwardRef as ReactComponent };